import { css } from "lit";

export const styles = css`
  .config-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 16px;
  }

  .section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .section-label {
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .aspect-ratio-options {
    display: flex;
    gap: 16px;
  }

  .aspect-option {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 16px;
    border: 2px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-border-radius-03);
    cursor: pointer;
    transition:
      border-color 0.2s,
      background-color 0.2s;
  }

  .aspect-option:hover,
  .aspect-option.selected {
    border-color: var(--sds-color-border-default-hover);
    background: var(--sds-color-background-default-hover);
  }

  .aspect-preview {
    background: var(--sds-color-background-default-secondary);
    border-radius: var(--sds-border-radius-02);
  }

  .aspect-preview.landscape {
    width: 64px;
    height: 36px;
  }

  .aspect-preview.portrait {
    width: 36px;
    height: 64px;
  }

  .aspect-label {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .audio-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: var(--sds-color-background-default-secondary);
    border-radius: var(--sds-border-radius-03);
  }

  .audio-label {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .permission-status {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-radius: var(--sds-border-radius-03);
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
  }

  .permission-status.checking {
    background: var(--sds-color-background-default-secondary);
    color: var(--sds-color-text-default-secondary);
  }

  .permission-status.granted {
    background: var(--sds-color-background-success-subtle);
    color: var(--sds-color-text-success-default);
  }

  .permission-status.denied {
    background: var(--sds-color-background-danger-subtle);
    color: var(--sds-color-text-danger-default);
  }

  .permission-status.prompt {
    background: var(--sds-color-background-warning-subtle);
    color: var(--sds-color-text-warning-default);
  }

  .modal-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    padding-top: 8px;
  }

  @media (max-width: 768px) {
    .aspect-ratio-options {
      flex-direction: column;
    }

    .modal-actions {
      flex-direction: column-reverse;
    }

    .modal-actions wow-button {
      width: 100%;
    }
  }
`;
